import Vue from 'vue';
import format from 'date-fns/format';

Vue.filter('capitalize', (value) => {
  if (!value) return '';
  const string = value.toString();
  return string.charAt(0).toUpperCase() + string.slice(1);
});

Vue.filter('formatDate', value => (value ? format(value, 'DD-MM-YYYY') : ''));
